import {
  POST_LETTER_CORRECTIONS_CORRECT_REQUEST,
  POST_LETTER_CORRECTIONS_CORRECT_SUCCESS,
  POST_LETTER_CORRECTIONS_CORRECT_FAILURE,
} from '../../constants/ActionTypes'

import { LetterCorrectionsApi } from '../api/LetterCorrectionsApi';

/*** POST /letter-corrections/correct ***/
const postCorrectRequest = () => ({
  type: POST_LETTER_CORRECTIONS_CORRECT_REQUEST,
});

const postCorrectSuccess = (data) => ({
  type: POST_LETTER_CORRECTIONS_CORRECT_SUCCESS,
  payload: {
    data: data
  }
});

const postCorrectFailure = (error) => ({
  type: POST_LETTER_CORRECTIONS_CORRECT_FAILURE,
  payload: {
    error: error
  }
});

export function postCorrect(data) {
  return async (dispatch) => {
    dispatch(postCorrectRequest());

    LetterCorrectionsApi.postCorrect(data, dispatch)
      .then((response) => {
        dispatch(postCorrectSuccess(response.data));
      })
      .catch((error) => {
        dispatch(postCorrectFailure(error.response));
      });
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/LetterCorrection.js